<template>
  <!-- 市场实销及变化趋势 -->
  <div>
    <!-- 近五年销量 增长率 -->
    <div class="table_container">
      <el-table
        ref="tableRef"
        highlight-current-row
        :border="true"
        :data="saleFiveYearsTableData"
        :header-cell-style="{
          background: '#EFEFEF',
          color: '#000',
          borderColor: '#dcdfe6'
        }"
        :cell-style="{ background: '#f2f2f2', borderColor: '#dcdfe6' }"
        show-summary
        :summary-method="getSummaries"
      >
        <!-- 近5年销量 -->
        <el-table-column label="近5年销量" align="center">
          <!-- 类别 -->
          <el-table-column
            prop="typeTwo"
            label="类别"
            min-width="90px"
            align="center"
          />
          <!-- 查询年-4 -->
          <el-table-column
            prop="firstShixiao"
            :label="`${Number(queryParams.years) - 4}年`"
            min-width="90px"
            align="center"
          />
          <!-- 查询年-3 -->
          <el-table-column
            prop="secondShixiao"
            :label="`${Number(queryParams.years) - 3}年`"
            min-width="90px"
            align="center"
          />
          <!-- 查询年-2 -->
          <el-table-column
            prop="thirdShixiao"
            :label="`${Number(queryParams.years) - 2}年`"
            min-width="90px"
            align="center"
          />
          <!-- 查询年-1 -->
          <el-table-column
            prop="fourthShixiao"
            :label="`${Number(queryParams.years) - 1}年`"
            min-width="90px"
            align="center"
          />
          <!-- 查询年 -->
          <el-table-column
            prop="fifthShixiao"
            :label="`${queryParams.years}年`"
            min-width="90px"
            align="center"
          />
        </el-table-column>
        <!-- 增长率 -->
        <el-table-column label="增长率" align="center">
          <!-- 查询年-4 -->
          <el-table-column
            prop="firstGrowthRate"
            :label="`${Number(queryParams.years) - 4}年`"
            min-width="90px"
            align="center"
          >
            <template slot-scope="scope">
              {{
                scope.row.firstGrowthRate === 0 || scope.row.firstGrowthRate
                  ? (scope.row.firstGrowthRate * 100).toFixed(0) + "%"
                  : "-"
              }}
            </template>
          </el-table-column>
          <!-- 查询年-3 -->
          <el-table-column
            prop="secondGrowthRate"
            :label="`${Number(queryParams.years) - 3}年`"
            min-width="90px"
            align="center"
          >
            <template slot-scope="scope">
              {{
                scope.row.secondGrowthRate === 0 || scope.row.secondGrowthRate
                  ? (scope.row.secondGrowthRate * 100).toFixed(0) + "%"
                  : "-"
              }}
            </template>
          </el-table-column>
          <!-- 查询年-2 -->
          <el-table-column
            prop="thirdGrowthRate"
            :label="`${Number(queryParams.years) - 2}年`"
            min-width="90px"
            align="center"
          >
            <template slot-scope="scope">
              {{
                scope.row.thirdGrowthRate === 0 || scope.row.thirdGrowthRate
                  ? (scope.row.thirdGrowthRate * 100).toFixed(0) + "%"
                  : "-"
              }}
            </template>
          </el-table-column>
          <!-- 查询年-1 -->
          <el-table-column
            prop="fourthGrowthRate"
            :label="`${Number(queryParams.years) - 1}年`"
            min-width="90px"
            align="center"
          >
            <template slot-scope="scope">
              {{
                scope.row.fourthGrowthRate === 0 || scope.row.fourthGrowthRate
                  ? (scope.row.fourthGrowthRate * 100).toFixed(0) + "%"
                  : "-"
              }}
            </template>
          </el-table-column>
          <!-- 查询年 -->
          <el-table-column
            prop="fifthGrowthRate"
            :label="`${queryParams.years}年`"
            min-width="90px"
            align="center"
          >
            <template slot-scope="scope">
              {{
                scope.row.fifthGrowthRate === 0 || scope.row.fifthGrowthRate
                  ? (scope.row.fifthGrowthRate * 100).toFixed(0) + "%"
                  : "-"
              }}
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
    </div>
    <!-- 查询年-1 市场实销 -->
    <div class="table_container">
      <el-table
        ref="tableRef"
        highlight-current-row
        :border="true"
        :data="firstSearchDataTableData"
        :header-cell-style="{
          background: '#EFEFEF',
          color: '#000',
          borderColor: '#dcdfe6'
        }"
        :cell-style="{ background: '#f2f2f2', borderColor: '#dcdfe6' }"
        show-summary
        :summary-method="getSummaries"
      >
        <!-- 市场实销 -->
        <el-table-column label="市场实销" align="center">
          <!-- 类别 -->
          <el-table-column
            prop="typeTwo"
            label="类别"
            min-width="90px"
            align="center"
          />
        </el-table-column>
        <!-- 查询年-1 -->
        <el-table-column
          :label="`${Number(queryParams.years) - 1}年`"
          align="center"
        >
          <!-- 实销 -->
          <el-table-column
            v-for="(item, index) in monthList"
            :key="index"
            :prop="item.shixiaoField"
            :label="item.month"
            min-width="90px"
            align="center"
          />
        </el-table-column>
        <el-table-column
          prop="total"
          label="合计"
          min-width="90px"
          align="center"
          class-name="total_column"
        >
          <template slot-scope="scope">
            {{ getColumnTotal(scope.row, "total", "shixiaoField") }}
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 查询年 市场实销 -->
    <div class="table_container">
      <el-table
        ref="tableRef"
        highlight-current-row
        :border="true"
        :data="secondSearchDataTableData"
        :header-cell-style="{
          background: '#EFEFEF',
          color: '#000',
          borderColor: '#dcdfe6'
        }"
        :cell-style="{ borderColor: '#dcdfe6' }"
        :cell-class-name="cellClassName"
        @cell-click="handleCellClick"
        show-summary
        :summary-method="getSummaries"
      >
        <!-- 市场实销 -->
        <el-table-column label="市场实销" align="center">
          <!-- 类别 -->
          <el-table-column
            prop="typeTwo"
            label="类别"
            min-width="90px"
            align="center"
            class-name="disabled_column"
          />
        </el-table-column>
        <!-- 查询年-1 -->
        <el-table-column
          :label="`${Number(queryParams.years)}年`"
          align="center"
        >
          <!-- 实销 -->
          <el-table-column
            v-for="(item, index) in monthList"
            :key="index"
            :prop="item.shixiaoField"
            :label="item.month"
            min-width="90px"
            align="center"
            :class-name="queryParams.years > 2024 ? '' : 'disabled_column'"
          >
            <template slot-scope="scope">
              <el-input-number
                v-if="
                  queryParams.years > 2024 &&
                    editField === item.shixiaoField &&
                    editIndex === scope.$index
                "
                id="focusRef"
                v-model="scope.row[item.shixiaoField]"
                class="number_input"
                :controls="false"
                :precision="0"
                size="mini"
                style="width: 100%"
                @blur="confirmEdit"
                @keyup.enter.native="confirmEdit"
              >
              </el-input-number>
              <span v-else>
                {{ scope.row[item.shixiaoField] }}
              </span>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column
          prop="total"
          label="合计"
          min-width="90px"
          align="center"
          class-name="total_column"
        >
          <template slot-scope="scope">
            {{ getColumnTotal(scope.row, "total", "shixiaoField") }}
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 查询年 同比 -->
    <div class="table_container">
      <el-table
        ref="tableRef"
        highlight-current-row
        :border="true"
        :data="tongbiTableData"
        :header-cell-style="{
          background: '#EFEFEF',
          color: '#000',
          borderColor: '#dcdfe6'
        }"
        :cell-style="{ background: '#f2f2f2', borderColor: '#dcdfe6' }"
        show-summary
        :summary-method="getSummaries"
      >
        <!-- 类别 -->
        <el-table-column
          prop="typeTwo"
          label=""
          min-width="90px"
          align="center"
        />
        <!-- 查询年同比 -->
        <el-table-column
          :label="`${Number(queryParams.years)}年同比`"
          align="center"
        >
          <!-- 同比 -->
          <el-table-column
            v-for="(item, index) in monthList"
            :key="index"
            :prop="item.tongbiHuanbiField"
            :label="item.month"
            min-width="90px"
            align="center"
          >
            <template slot-scope="scope">
              {{
                scope.row[item.tongbiHuanbiField] === 0 ||
                scope.row[item.tongbiHuanbiField]
                  ? (scope.row[item.tongbiHuanbiField] * 100).toFixed(0) + "%"
                  : "-"
              }}
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column
          prop="totalRate"
          label="合计"
          min-width="90px"
          align="center"
          class-name="total_column"
        >
          <template slot-scope="scope">
            {{
              (
                getColumnTotal(scope.row, "totalRate", "tongbiHuanbiField") *
                100
              ).toFixed(0) + "%"
            }}
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 查询年 环比 -->
    <div class="table_container">
      <el-table
        ref="tableRef"
        highlight-current-row
        :border="true"
        :data="huanbiTableData"
        :header-cell-style="{
          background: '#EFEFEF',
          color: '#000',
          borderColor: '#dcdfe6'
        }"
        :cell-style="{ background: '#f2f2f2', borderColor: '#dcdfe6' }"
        show-summary
        :summary-method="getSummaries"
      >
        <!-- 类别 -->
        <el-table-column
          prop="typeTwo"
          label=""
          min-width="90px"
          align="center"
        />
        <!-- 查询年环比 -->
        <el-table-column
          :label="`${Number(queryParams.years)}年环比`"
          align="center"
        >
          <!-- 环比 -->
          <el-table-column
            v-for="(item, index) in monthList"
            :key="index"
            :prop="item.tongbiHuanbiField"
            :label="item.month"
            min-width="90px"
            align="center"
          >
            <template slot-scope="scope">
              {{
                scope.row[item.tongbiHuanbiField] === 0 ||
                scope.row[item.tongbiHuanbiField]
                  ? (scope.row[item.tongbiHuanbiField] * 100).toFixed(0) + "%"
                  : "-"
              }}
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column
          prop="totalRate"
          label="合计"
          min-width="90px"
          align="center"
          class-name="total_column"
        >
          <template slot-scope="scope">
            {{
              (
                getColumnTotal(scope.row, "totalRate", "tongbiHuanbiField") *
                100
              ).toFixed(0) + "%"
            }}
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { addOrUpdateMarketSaleChangeTrendApi } from "@/api/saleTaskCollection";

export default {
  data() {
    return {
      queryParams: {},
      saleFiveYearsTableData: [], // 近5年销量 和 增长率
      firstSearchDataTableData: [], // 前一年市场实销
      secondSearchDataTableData: [], // 当前年市场实销
      tongbiTableData: [], // 同比
      huanbiTableData: [], // 环比
      editField: "", // 编辑单元格
      editIndex: -1, // 编辑行索引
      monthList: [
        {
          month: "1月",
          shixiaoField: "oneShixiao",
          tongbiHuanbiField: "oneRate"
        },
        {
          month: "2月",
          shixiaoField: "twoShixiao",
          tongbiHuanbiField: "twoRate"
        },
        {
          month: "3月",
          shixiaoField: "threeShixiao",
          tongbiHuanbiField: "threeRate"
        },
        {
          month: "4月",
          shixiaoField: "fourShixiao",
          tongbiHuanbiField: "fourRate"
        },
        {
          month: "5月",
          shixiaoField: "fiveShixiao",
          tongbiHuanbiField: "fiveRate"
        },
        {
          month: "6月",
          shixiaoField: "sixShixiao",
          tongbiHuanbiField: "sixRate"
        },
        {
          month: "7月",
          shixiaoField: "sevenShixiao",
          tongbiHuanbiField: "sevenRate"
        },
        {
          month: "8月",
          shixiaoField: "eightShixiao",
          tongbiHuanbiField: "eightRate"
        },
        {
          month: "9月",
          shixiaoField: "nineShixiao",
          tongbiHuanbiField: "nineRate"
        },
        {
          month: "10月",
          shixiaoField: "tenShixiao",
          tongbiHuanbiField: "tenRate"
        },
        {
          month: "11月",
          shixiaoField: "elevenShixiao",
          tongbiHuanbiField: "elevenRate"
        },
        {
          month: "12月",
          shixiaoField: "twelveShixiao",
          tongbiHuanbiField: "twelveRate"
        }
      ] // 月度
    };
  },
  methods: {
    init(data, queryParams = {}) {
      this.saleFiveYearsTableData = data.saleFiveYears || [];
      this.firstSearchDataTableData = [];
      data.firstSearchData?.map(item => {
        this.firstSearchDataTableData.push({ ...item, total: 0 });
      });
      this.secondSearchDataTableData = [];
      data.secondSearchData?.map(item => {
        this.secondSearchDataTableData.push({ ...item, total: 0 });
      });
      this.tongbiTableData = [];
      data.tongbi?.map(item => {
        this.tongbiTableData.push({ ...item, totalRate: 0 });
      });
      this.huanbiTableData = [];
      data.huanbi?.map(item => {
        this.huanbiTableData.push({ ...item, totalRate: 0 });
      });
      this.queryParams = { ...queryParams };
    },
    // 合计
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            }
            return prev;
          }, 0);
          // 增长率、同比环比 显示百分比
          if (column.property.includes("Rate")) {
            sums[index] = (sums[index] * 100).toFixed(0) + "%";
          }
        } else {
          sums[index] = "";
        }
      });
      return sums;
    },
    // 获取当前行合计
    getColumnTotal(row, totalField, field) {
      let total = 0;
      this.monthList.forEach(item => {
        const value = Number(row[item[field]]);
        if (!isNaN(value)) {
          total += value;
        }
      });
      row[totalField] = total;
      return total;
    },
    // 获取单元格索引
    cellClassName({ row, column, rowIndex, columnIndex }) {
      row.index = rowIndex;
      column = { ...column, index: columnIndex };
    },
    // 点击单元格
    handleCellClick(row, column) {
      this.handleColumn(column.property, row.index ?? -1);
      this.secondSearchDataTableData[row.index][column.property] =
        this.secondSearchDataTableData[row.index][column.property] ?? undefined;
    },
    // 点击单元格编辑
    handleColumn(field, index) {
      this.editField = field;
      this.editIndex = index ?? -1;
      this.$nextTick(() => {
        document.querySelector("#focusRef")?.focus();
        document.querySelector("#focusRef .el-input__inner")?.focus();
      });
    },
    // 确认编辑
    confirmEdit() {
      this.editField = "";
      this.editIndex = -1;
    },
    // 保存
    async handleSave(callBack) {
      try {
        const submitData = {
          ...this.queryParams,
          data: {
            secondSearchData: JSON.parse(
              JSON.stringify(this.secondSearchDataTableData)
            )
          }
        };
        const res = await addOrUpdateMarketSaleChangeTrendApi(submitData);
        if (res.status == 0) {
          this.$DonMessage.success("操作成功！");
          this.secondSearchDataTableData = [];
          res.data.secondSearchData?.map(item => {
            this.secondSearchDataTableData.push({ ...item, total: 0 });
          });
          this.tongbiTableData = [];
          res.data.tongbi?.map(item => {
            this.tongbiTableData.push({ ...item, totalRate: 0 });
          });
          this.huanbiTableData = [];
          res.data.huanbi?.map(item => {
            this.huanbiTableData.push({ ...item, totalRate: 0 });
          });
          callBack();
        } else {
          this.$DonMessage.error(res.message);
        }
      } catch (error) {
        console.error(error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.table_container {
  padding: 15px 18px 0 50px;
  .number_input {
    width: 100%;
    padding: 0;
    ::v-deep .el-input__inner {
      padding: 0 8px;
    }
  }
  ::v-deep {
    .disabled_column {
      background: #f2f2f2 !important;
    }
    .total_column,
    .el-table__footer-wrapper tbody td.el-table__cell {
      background: #c0cfde !important;
    }
  }
}
</style>
